<template>
  <div>
    <b-card
      class=""
      no-body
      :class="{ 'my-1': is_describe_yourself == 'false' }"
    >
      <b-card-body>
        <b-card-sub-title
          v-if="is_describe_yourself == 'true'"
          class="subtitle-mid-question"
          >{{ title }}</b-card-sub-title
        >
        <!-- <div class="row" v-else>
          <div class="col-md-9">
            <b-form-group
              :label="'Question ' + (index + 1)"
              label-for="title"
              :title="title"
              label-class="form-label-mid form-label-question-mid"
            >
              <b-form-textarea
                id="title"
                class="form-control-mid"
                v-model="title"
                :title="title"
                rows="3"
                >{{ title }}</b-form-textarea
              >
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-button
              variant="action"
              class="
                btn btn-bumblebee btn-mid
                mb-1
                btn-delete-input-mid
                delete-action
              "
              @click="clickDeleteQuestion(question_id)"
            >
              Delete Question
            </b-button>
          </div>
        </div> -->

        <p class="question-options-label-mid">Options:</p>
        <div class="row">
          <div class="col-md-9">
            <div
              v-for="(option, index) in options"
              :key="option.id"
              class="question-option-mid"
            >
              <div class="float-left">
                <b-form-input
                  v-model="edit_option_value"
                  v-if="
                    (edit_option_id != null && edit_option_id == option.id) ||
                    (question_id == null && edit_option_index == index)
                  "
                ></b-form-input>

                <p class="value" v-else> {{ option.name }}</p>
              </div>
              <div
                class="float-right"
                v-if="edit_option_id != null && edit_option_id == option.id"
              >
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    delete-action
                    ml-1
                  "
                  @click="clickCancelOption(question_id, option.id)"
                >
                  Cancel
                </b-button>
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    edit-action
                  "
                  v-if="!is_loading_edit"
                  @click="clickConfirmEditOption(option.id)"
                >
                  Save
                </b-button>
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    save-action
                  "
                  disabled
                  v-else
                >
                  <b-spinner
                    small
                    label="Small Spinner"
                    variant="light"
                  ></b-spinner>
                  Loading
                </b-button>
              </div>
              <div class="float-right" v-else>
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    delete-action
                    ml-1
                  "
                  @click="clickDeleteOption(option.id)"
                >
                  Delete
                </b-button>
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    edit-action
                  "
                  @click="clickEditOption(option.id, option.name)"
                >
                  Edit
                </b-button>
              </div>
            </div>
            <div class="question-option-mid add-option-mid">
              <div class="float-left">
                <!-- <p class="add-new">Add new</p> -->
                <b-form-input
                  v-model="new_option_value"
                  v-if="is_add_option == true"
                ></b-form-input>

                <b-button
                  v-else
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    add-action
                  "
                  @click="clickAddOption()"
                >
                  Add new
                </b-button>
              </div>
              <div class="float-right" v-if="is_add_option == true">
                <!-- <p class="save-action">Save</p> -->
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    delete-action
                    ml-1
                  "
                  @click="clickCancelAddOption"
                >
                  Cancel
                </b-button>
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    save-action
                  "
                  v-if="!is_loading_add"
                  @click="clickSaveNewOption()"
                >
                  Save
                </b-button>
                <b-button
                  variant="action"
                  class="
                    btn btn-bumblebee btn-mid
                    mb-1
                    btn-edit-input-mid
                    save-action
                  "
                  disabled
                  v-else
                >
                  <b-spinner
                    small
                    label="Small Spinner"
                    variant="light"
                  ></b-spinner>
                  Loading
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row" v-if="is_describe_yourself == 'false'">
          <div class="col-md-3 offset-md-9">
            <b-button
              variant="mid-primary"
              class="btn btn-bumblebee btn-mid btn-mid-submit float-right"
              @click="clickSaveQuestion"
            >
              Save changes
            </b-button>
          </div>
        </div> -->
      </b-card-body>
    </b-card>

    <!-- delete modal -->
    <b-modal
      id="deleteModal"
      centered
      :modal-class="
        client_name == 'DY' ? 'modal-doom-yoga' : 'modal-irish-date'
      "
    >
      <div class="d-block mb-4">
        <!-- <input id="event_id" name="event_id" type="hidden" v-model="event_id" />
        <input id="client" name="client" type="hidden" v-model="client_name" /> -->
        <p
          class="confirmMessageModalP my-4"
          v-bind:class="{
            'message-modal-dy': client_name == 'DY',
            'message-modal-mid': client_name == 'MID',
          }"
        >
          Are you sure to delete this {{ item_name }}?
        </p>
      </div>
      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID' ? 'mid-danger' : 'doomyoga-primary'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              v-if="!is_loading_delete"
              @click="clickConfirmDelete"
            >
              Yes
            </b-button>
            <b-button
              type="button"
              :variant="
                client_name == 'MID' ? 'mid-danger' : 'doomyoga-primary'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga  btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              disabled
              v-else
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="light"
              ></b-spinner>
              Loading
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              :variant="
                client_name == 'MID'
                  ? 'mid-secondary-outline'
                  : 'doomyoga-danger-outline'
              "
              class="w-100 btn-bumblebee"
              v-bind:class="{
                'btn-doomyoga btn-doom-yoga-submit': client_name == 'DY',
                'btn-mid btn-mid-submit': client_name == 'MID',
              }"
              @click="closeModalDelete"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!-- end delete modal-->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DescribeWords",
  props: [
    "client_name",
    "is_describe_yourself",
    "index",
    "question_id",
    "title",
    "options",
  ],
  components: {},
  data() {
    return {
      question: null,
      selected_option_id: null,
      item_name: "item",
      item_index: null,
      edit_option_id: null,
      edit_option_value: null,
      edit_option_index: null,
      is_add_option: false,
      new_option_value: null,
      is_loading_add: false,
      is_loading_edit: false,
      is_loading_delete: false,
    };
  },
  mounted() {},
  updated() {},
  methods: {
    clickAddOption() {
      console.log("click add word ");
      this.is_add_option = true;
    },

    clickSaveNewOption() {
      console.log("click save new word ", this.new_option_value);
      this.is_loading_add = true;

      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("name", this.new_option_value);

      axios
        .post("social/admin/words", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Word is added successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading_add = false;
          this.is_add_option = false;
          this.new_option_value = null;
          //   this.$bvModal.hide("addInterestModal");
          //   this.getInterestsList();
          this.$parent.getDescribeWords();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading_add = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    clickCancelAddOption() {
      console.log("click cancel new option ");
      this.is_add_option = false;
      this.new_option_value = null;
    },

    clickDeleteOption(option_id) {
      console.log("delete word " + option_id + " " + this.index + " ");

      this.selected_option_id = option_id;
      this.item_name = "option";
      this.$root.$emit("bv::show::modal", "deleteModal");
    },
    clickConfirmDelete() {
      // let formData = new FormData();
      // formData.append("event_id", $("#deleteModal #event_id").val());
      // let eventId = $("#deleteModal #event_id").val();
      // let client = $("#deleteModal #client").val();
      this.is_loading_delete = true;
      console.log(
        "delete ",
        this.item_name,
        ",",
        this.selected_option_id
      );

      axios
        .delete("social/admin/words/" + this.selected_option_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Word is deleted successfully.",
            type: "success",
            timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading_delete = false;
          this.$bvModal.hide("deleteModal");
          this.$parent.getDescribeWords();
          // this.$router.go();
          // this.events = response.data.events;
        })
        .catch((error) => {
          console.log(error.response.error);
          console.log(error.request);
          console.log(error.message);
          this.is_loading_delete = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteModal");
    },

    clickEditOption(option_id, option_name) {
      console.log("edit option " + option_id + " " + option_name);

      this.edit_option_id = option_id;
      this.edit_option_value = option_name;
    },
    clickCancelOption(option_id) {
      console.log("cancel option " + +" " + option_id);

      this.edit_option_id = null;
      this.edit_option_value = null;
      //   this.edit_option_index = null;
    },

    clickConfirmEditOption(option_id) {
      console.log(
        "click confirm edit option ",
        option_id,
        this.edit_option_value,
        this.edit_option_id
      );

      this.is_loading_edit = true;

      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("name", this.edit_option_value);
      formData.append("_method", "put");

      axios
        .post("social/admin/words/" + this.edit_option_id, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Word is updated successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$parent.getDescribeWords();

          this.edit_option_id = null;
          this.edit_option_value = null;
          this.is_loading_edit = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading_edit = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
      // console.log(this.$parent)
      // console.log(this.$parent.$parent)
      // console.log(this.$parent.$parent.$parent)
      // this.$parent.$parent.$parent.questions.push(this.$parent.$parent.$parent.questions[0])
    },
  },
};
</script>
<style >
.form-group label.form-label-mid.form-label-question-mid {
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/my_irish_date/single_question/word.vue